export default "__VITE_ASSET__72MM8lKA__"